import { Head } from "vite-react-ssg";
import { SEO_ROUTES, canonical, type RobotsDirective } from "./routes";

type SeoProps = {
  path?: string;
  title?: string;
  description?: string;
  robots?: RobotsDirective;
  jsonLd?: object[];
};

const Seo = ({ path, title, description, robots, jsonLd = [] }: SeoProps) => {
  const route = path ? SEO_ROUTES.find((r) => r.path === path) : undefined;

  const finalTitle = title ?? route?.title;
  const finalDescription = description ?? route?.description;
  const finalRobots = robots ?? route?.robots;
  const canonicalPath = path ?? route?.path;

  if (!finalTitle && !finalDescription && !finalRobots && jsonLd.length === 0) {
    return null;
  }

  return (
    <Head>
      {finalTitle && <title>{finalTitle}</title>}
      {finalDescription && <meta name="description" content={finalDescription} />}
      {canonicalPath && <link rel="canonical" href={canonical(canonicalPath)} />}
      {finalRobots && <meta name="robots" content={finalRobots} />}
      {jsonLd.map((data, index) => (
        <script key={index} type="application/ld+json">
          {JSON.stringify(data)}
        </script>
      ))}
    </Head>
  );
};

export default Seo;
